import { ActionLink } from "@diffex/ui";

import { PublicLayout } from "../components/PublicLayout";
import { productConfig } from "../config";

export function NotFoundPage() {
  return (
    <PublicLayout>
      <p className="eyebrow">404</p>
      <h1>This page is not in the workspace</h1>
      <p>Return to your dashboard or visit the Diffex website.</p>
      <div className="public-actions">
        <ActionLink href="/">
          Go to dashboard
        </ActionLink>
        <ActionLink href={productConfig.marketingOrigin} tone="secondary">
          Visit Diffex
        </ActionLink>
      </div>
    </PublicLayout>
  );
}
